import { Alert } from '../utils/alert';

export class ResourceList {
  static start() {
    const $elements = $('.resource-list');

    if ($elements) {
      $elements.each(function init_resource_lists() {
        const $element = $(this);

        $element.data('resourcelist', new ResourceList($element));
      });
    }
  }

  constructor($element) {
    this.$element = $element;
    this.url = $element.data('resource-url');
    this.rowLink = $element.data('resource-rowlink') === undefined ? true : $element.data('resource-rowlink');

    if (this.url) this.bind_events();
  }

  bind_events() {
    // this.$element.on('click', 'a[target="_blank"][href^="mailto:"]', (event) => { this.handle_mailto_link(event) })
    if (this.rowLink) this.$element.on('click', 'td:not(.resource-actions)', (event) => this.handle_row_action(event));
    this.$element.on('click', '[data-resource-action]', (event) => this.handle_resource_action(event));
  }

  handle_row_action(event) {
    if (event.target.tagName !== 'A') {
      const $target = $(event.currentTarget);
      const id = $target.parent().data('resource-id');

      if (id) {
        const url = this.url.replace(/:id/, id);

        window.location.assign(url);
      }
    }
  }

  handle_resource_action(event) {
    const $element = $(event.currentTarget);
    const id = $element.parents('tr').data('resource-id');
    let confirmation = ($element.data('resource-confirm') ? $element.data('resource-confirm') : null);

    if ($element.data('resource-toggle') && $element.data('resource-value') !== undefined) {
      if ($element.data('resource-value') && $element.data('resource-confirm-on')) {
        confirmation = $element.data('resource-confirm-on');
      }
      else if (!$element.data('resource-value') && $element.data('resource-confirm-off')) {
        confirmation = $element.data('resource-confirm-off');
      }
    }

    if (!$element.hasClass('disabled') && (confirmation == null || window.confirm(confirmation))) {
      const ajax_settings = {
        url: `${this.url.replace(/:id/, id)}/${$element.data('resource-action')}`,
        dataType: 'json',
        contentType: 'application/json',
        success: (data) => this.handle_resource_action_success(data, $element),
        error: (data) => this.handle_resource_action_failure(data),
      };

      if ($element.data('resource-method')) {
        ajax_settings.type = $element.data('resource-method');
      }
      else {
        ajax_settings.type = 'POST';
      }

      if ($element.data('resource-value') !== undefined) {
        ajax_settings.data = JSON.stringify({ value: $element.data('resource-value') });
      }

      $.ajax(ajax_settings);
    }
  }

  handle_resource_action_success(data, $element) {
    if (data.success) {
      if (data.message) {
        Alert.success(data.message);
      }

      if (data.replace) {
        $element.replaceWith(data.replace);
      }

      if (data.remove) {
        $element.remove();
      }

      if (data.disabled) {
        $element.addClass('disabled');
      }

      if (data.value && $element.data('resource-refresh')) {
        const refresh_selector = $element.data('resource-refresh');
        const $refresh = $element.parents('tr').find(refresh_selector);

        $refresh.html(data.value);
      }

      if (data.next_value !== undefined) {
        if ($element.data('resource-value') !== undefined) {
          $element.data('resource-value', data.next_value);
        }

        if ($element.data('resource-toggle')) {
          if (data.next_value) {
            $element.find('.toggle-on').removeClass('d-none');
            $element.find('.toggle-off').addClass('d-none');
          }
          else {
            $element.find('.toggle-on').addClass('d-none');
            $element.find('.toggle-off').removeClass('d-none');
          }
        }
      }
    }

    else {
      this.handle_resource_action_failure(null, data);
    }
  }

  static handle_resource_action_failure(request, data) {
    if (data && data.error) {
      Alert.error(data.error);
    }
    else {
      Alert.error('Es ist ein Fehler aufgetreten.');
    }

    if (request != null) {
      console.error(request.responseText);
    }
  }
}
